import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NOT_FOUND_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': 'https://phennx.io/404#webpage',
      url: 'https://phennx.io/404',
      name: 'Page not found',
      description: 'The page you requested could not be found on the Phennx website.',
      isPartOf: { '@id': 'https://phennx.io/#website' },
      about: { '@id': 'https://phennx.io/#organization' },
    },
    {
      '@type': 'BreadcrumbList',
      '@id': 'https://phennx.io/404#breadcrumbs',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://phennx.io/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Page not found',
          item: 'https://phennx.io/404',
        },
      ],
    },
  ],
};

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page not found - Phennx"
        description="We couldn't find that page. Visit the Phennx homepage or explore our latest updates."
        path="/404"
        image="/logo-full-transparent.png"
        type="website"
        schema={NOT_FOUND_SCHEMA}
        robots="noindex, nofollow"
      />
      <section className="section" aria-label="Page not found">
        <div className="section-inner" style={{ textAlign: 'center' }}>
          <p className="about-page-hero__eyebrow">404</p>
          <h1 className="section-title">We can&apos;t find that page.</h1>
          <p className="section-subtitle">
            The link may be out of date or the page may have moved. Use the options below to get back on track.
          </p>
          <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link className="btn-primary" to="/">
              Back to home
            </Link>
            <Link className="btn-secondary" to="/blog">
              Visit news
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
